export const UPDATE_2048_SCORES = "UPDATE_2048_SCORES"